import {
  Paper,
  Title,
  Badge,
  Divider,
  Group,
  Stack,
  Anchor,
  Center,
  type PaperProps
} from '@mantine/core'
import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

type Props = {
  title: string
  icon?: ReactNode
  badge?: {
    text: string
    color: string
  }
  children: ReactNode
  footer?: {
    text: string
    href?: string
    to?: string
    onMouseEnter?: () => void
  }
} & PaperProps

export const InfoCard = ({
  title,
  icon,
  badge,
  children,
  footer,
  ...props
}: Props) => {
  return (
    <Paper withBorder flex={1} {...props}>
      <Group justify="space-between" mb="lg">
        <Group gap={8}>
          <Title order={2} fz="lg" fw={700} size="md">
            {title}
          </Title>
          {icon}
        </Group>
        {badge && (
          <Badge variant="light" color={badge.color} radius="sm" tt="none">
            {badge.text}
          </Badge>
        )}
      </Group>

      <Stack gap={4}>{children}</Stack>

      {footer && (
        <>
          <Divider my="sm" />
          <Center>
            {footer.to ? (
              <Anchor
                component={Link}
                to={footer.to}
                c="gray.7"
                size="xs"
                fw={600}
                td="none"
                onMouseEnter={footer.onMouseEnter}
              >
                {footer.text}
              </Anchor>
            ) : (
              <Anchor
                href={footer.href}
                c="gray.7"
                size="xs"
                fw={600}
                td="none"
                onMouseEnter={footer.onMouseEnter}
              >
                {footer.text}
              </Anchor>
            )}
          </Center>
        </>
      )}
    </Paper>
  )
}
